const formatPrice = (value = 0, opts?: { isCents?: boolean, withCurrency?: boolean, toFixed?: number, removeZeroCents?: boolean }): string => {
  const { isCents = true, withCurrency = true, toFixed = 2, removeZeroCents = false } = opts || {}

  const modifier = value < 0 ? '- ' : ''
  const currency = withCurrency ? '$' : ''

  let formattedValue = Math.abs(isCents ? value / 100 : value).toFixed(toFixed)

  if (removeZeroCents) {
    formattedValue = formattedValue.replace('.00', '')
  }

  return `${modifier}${currency}${formattedValue}`
}


export default formatPrice
